/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";
import { get, isEmpty } from "lodash";
import { getCookie } from "framework/libs/cookie";
import { TOKEN_CONGDONG, TOKEN_SHOP } from "framework/store/constants";
import http from "utilities/http";
import dayjs from "dayjs";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import parse from 'html-react-parser';
import Image from 'next/image';
export default function Index({ coupon, profession, isSave, isInPage = false, isPersonalPage = false, isInMembership = false }) {
    const [state, _setState] = useState({
        item: coupon,
        modal: false,
        isSave: isSave,
        modalComplete: false,
    });
    let vendorLogo = coupon?.file?.storage_thumbnail_url || profession?.avatar || coupon.professional?.avatar;
    let vendorName = profession?.display_name || profession?.company || profession?.name || profession?.vendor_id;

    if (coupon.professional) {
        vendorLogo = coupon.professional.avatar || vendorLogo;
        vendorName = coupon.professional.display_name || coupon.professional.company || coupon.professional.name || vendorName;
    }
    const setState = (_state = {}) => {
        _setState({
            ...state,
            ..._state
        });
    };
    useEffect(() => {
        setState({ isSave: isSave });
    }, [isSave]);
    const saveCoupon = async () => {
        setState({ modal: false });
        if (isEmpty(getCookie(TOKEN_CONGDONG))) {
            toast.info('Bạn cần đăng nhập trước khi lưu mã giảm giá');
            return;
        };
        setState({ isSave: true });
        const res = await http('community/me/voucher', {}, {
            token: `Bearer ${getCookie(TOKEN_CONGDONG)}`,
            method: 'POST',
            body: {
                voucher_id: coupon.id,
            }
        }, 'v2');
        if (!res.success) toast.error(res.message);
    };

    const deleteCoupon = async () => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) {
            toast.info('Đã có lỗi xảy ra.');
            return;
        };
        setState({ isSave: false });
        const res = await http(`community/me/voucher/${coupon.id}`, {}, {
            token: `Bearer ${getCookie(TOKEN_CONGDONG)}`,
            method: 'DELETE',
        }, 'v2');
        if (!res.success) toast.error(res.message);
    };

    const useCoupon = async () => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) {
            toast.info('Bạn cần đăng nhập trước khi sử dụng mã giảm giá');
            return;
        };
        setState({ 
            modalConfirm: false,
            // modal: false,
        });
        const res = await http(`community/me/voucher/${coupon.id}/apply`, {}, {
            token: `Bearer ${getCookie(TOKEN_CONGDONG)}`,
            method: 'POST',
        }, 'v2');
        if (!res.success) {
            setState({ 
                modal: false,
                modalConfirm: false,
            });
            toast.error(res.message);
        }
        if (res.success) {
            toast.info('Cảm ơn bạn đã sử dụng voucher!');
            // deleteCoupon();
        };
    };

    const couponContent = (modal) => {
        const expirationDate = dayjs(state?.item.end_time).diff(dayjs(), 'day');
        if (isInMembership && !modal) {
            return <div className="dealsInfo cursor-pointer" onClick={() => setState({ modal: true })}>
                <div className="dealsInfo-thumb">
                    <a><img src={vendorLogo || '/images/icon-coupon.png'} alt="" /></a>
                </div>
                <div className="dealsInfo-content">
                    <p className="dealsInfo-label">{vendorName}</p>
                    <h3 className="dealsInfo-tlt"><a>{state.item?.name}</a></h3>
                    {/* <p className="dealsInfo-point"><span>500</span> điểm</p> */}
                </div>
            </div>;
        }
        return <div className="discountBox" style={modal ? { backgroundColor: 'white' } : {}}>
            <div className="discount-design">
                <div className="discount-thumb wrap-next-image-not-crop" style={{ position: 'relative' }}>
                    <Image src={vendorLogo || '/images/icon-coupon.png'} layout='fill' alt="" />
                </div>
                <p>{vendorName}</p>
            </div>
            <div className="discount-content">
                <div className="discount-info">
                    <h3 className="discount-title">{state.item?.name}</h3>
                    {/* {!isInPage && <p className="discount-inhaus"> {vendorName}</p>} */}
                    <p className="discount-expiryDate">HSD: {modal ? dayjs(state?.item?.start_time).format('DD.MM.YYYY') + ' - ' : ''} {dayjs(state?.item?.end_time).format('DD.MM.YYYY')}</p>
                    <p className="discount-dateTime">
                        {expirationDate > 0 && `Còn ${expirationDate} ngày sẽ hết hạn`}
                        {expirationDate == 0 && 'Hết hạn trong hôm nay'}
                        {expirationDate < 0 && 'Đã hết hạn'}
                    </p>

                    {modal ? <></> : <span className="item-infoSquare" onClick={() => setState({ modal: true })}></span>}
                    <div className="discount-btn">
                        {!state.isSave && expirationDate <= 0 && <button className="btn btn--gray" disabled>Đã hết hạn</button>}
                        {
                            // state.item?.can_save && 
                            // !state.item.is_limit_reached &&
                            !state.isSave && expirationDate > 0 && <button className="btn btn--blue" onClick={() => { saveCoupon(state?.item); }}>Lưu</button>}
                        {state.isSave && <button className="btn btn--gray" onClick={() => { deleteCoupon(state?.item); }}>Đã lưu</button>}
                        {/* {state.item.is_limit_reached && <button className="btn btn--gray">Hết lượt dùng</button>} */}
                    </div>
                </div>
            </div>
        </div>;
    };

    const getCouponDescription = () => {
        let couponDes = state?.item?.description || "";

        if (!couponDes) return <></>;

        return <>
            <h3 className="mtitle">Ưu đãi</h3>
            <div className="text">{parse(couponDes)}</div>
        </>;
    };

    return <li className={state?.item?.code ? "" : "code-promo"}>
        <Modal show={state.modal} onHide={() => { setState({ modal: false }); }} className="modal_conditions-code">
            <Modal.Header closeButton>
                <h5 className="modal-title">Điều kiện sử dụng mã</h5>
            </Modal.Header>
            <Modal.Body >
                <div className="discount">
                    <ul><li className={"w-100 " + (state?.item?.code ? "" : "code-promo")}>{couponContent(true)}</li></ul>
                </div>

                <h3 className="mtitle">Mã code</h3>
                <p className="text">{state?.item?.code}</p>

                {getCouponDescription()}

                <h3 className="mtitle">Hạn sử dụng</h3>
                <p className="text">{state?.item?.start_time} đến {state?.item?.end_time}</p>
            </Modal.Body>
            <Modal.Footer>
                {!isPersonalPage && <Button style={{ width: "50%" }} variant="primary" onClick={() => { setState({ modal: false }); }} className="btn">Xong</Button>}
                {isPersonalPage && !state.item.is_limit_reached && <Button style={{ width: "100%" }} variant="primary" onClick={() => setState({ modalConfirm: true })} className="btn">Sử dụng voucher</Button>}
                {isPersonalPage && state.item.is_limit_reached && <Button style={{ width: "100%" }} variant="primary" disabled className="btn">Đã hết lượt sử dụng voucher</Button>}
            </Modal.Footer>
        </Modal>

        {couponContent()}

        <Modal show={state.modalConfirm} onHide={() => setState({ modalConfirm: false })}
            className="modal--confirm">
            <Modal.Header closeButton>
                {/* <Modal.Title>
                </Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
                <div className="confirm-icon mb-3 text-center"><img src="/images/icon-radio-tick.svg" align="" alt=""/></div>
                <h3 className="confirm-title">Xác nhận sử dụng voucher</h3>
                <p className="text-center">Bạn xác nhận sử dụng voucher <b>{state?.item?.code}</b>?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button style={{ width: "50%" }} variant="outline-primary" onClick={() => setState({ modalConfirm: false })}>
                    Hủy
                </Button>
                <Button style={{ width: "50%" }} variant="primary" onClick={() => {
                    useCoupon();
                }}>
                    Đồng ý
                </Button>
            </Modal.Footer>
        </Modal>
    </li>;
}